import { Button, Col, Collapse, Drawer, Row } from "antd";
import React, { useEffect, useState } from "react";

import { ExternalLink } from "react-feather";
import styles from "./ProductDrawer.module.scss";

export const specsConstants = {
  size: "Size",
  application: "Application",
  availability: "Availability",
  backingDetails: "Backing Details",
  backingType: "Backing Type",
  baseMaterial: "Base Material",
  category: "Category",
  countryOfOrigin: "Country Of Origin",
  cityOfOrigin: "City Of Origin",
  construction: "Construction",
  collectionName: "Collection Name",
  collectionTag: "Collection Tag",
  currency: "Currency",
  coverageArea: "Coverage Area",
  design: "Design",
  // description: 'Description',
  embroidery: "Embroidery",
  faceVeneerSize: "Face Veneer Size",
  face: "Face",
  features: "Features",
  fibreType: "Fibre Type",
  finish: "Finish",
  form: "Form",
  glassThickness: "Glass Thickness",
  grainType: "Grain Type",
  handleType: "Handle Type",
  indoorOutdoor: "Indoor/Outdoor",
  leadTime: "Lead Time",
  length: "Length",
  layingPattern: "Laying Pattern",
  maximumPanelWidth: "Maximum Panel Width",
  maximumSashHeight: "Maximum Sash Height",
  maximumShutterArea: "Maximum Shutter Area",
  maximumShutterHeight: "Maximum Shutter Height",
  maximumShutterWidth: "Maximum Shutter Width",
  maximumWidth: "Maximum Width",
  mediaThickness: "Media Thickness",
  mediaType: "Media Type",
  minimumVisibleInterlock: "Minimum Visible Interlock",
  minimumWidth: "Minimum Width",
  pattern: "Pattern",
  packingSize: "Packing Size",
  placeOfOrigin: "Place Of Origin",
  priceLowerLimit: "Price Lower Limit",
  priceUpperLimit: "Price Upper Limit",
  productSize: "Product Size",
  productName: "Product Name",
  projectType: "Project Type",
  quantity: "Quantity",
  repeatPattern: "Repeat Pattern",
  sampleSize: "Sample Size",
  sampleLength: "Sample Length",
  sampleWidth: "Sample Width",
  sectionDepth: "Section Depth",
  series: "Series",
  species: "Species",
  specifications: "Specifications",
  supplierName: "SupplierName",
  tags: "Tags",
  texture: "Texture",
  thickness: "Thickness",
  tileLook: "Tile Look",
  type: "Type",
  typicalTurnaroundTime: "Typical Turnaround Time",
  warranty: "Warranty",
  warrantyDetails: "Warranty Details",
  wearLayerThickness: "Wear Layer Thickness",
  weight: "Weight",
  weightPerBoxLowerLimit: "Weight Per Box Lower Limit",
  weightPerBoxUpperLimit: "Weight Per Box Upper Limit",
  width: "Width",
  yarnComposition: "Yarn Composition",
  categoryName: "Category",
};

const dimensionConst = [
  "coverageArea",
  "face",
  "faceVeneerSize",
  "glassThickness",
  "length",
  "maximumPanelWidth",
  "maximumSashHeight",
  "maximumShutterArea",
  "maximumShutterHeight",
  "maximumShutterWidth",
  "maximumWidth",
  "mediaThickness",
  "minimumWidth",
  "packingSize",
  "productSize",
  "sampleSize",
  "sampleLength",
  "sampleWidth",
  "sectionDepth",
  "thickness",
  "wearLayerThickness",
  "weightPerBoxLowerLimit",
  "weightPerBoxUpperLimit",
  "width",
];

const majorConst = [
  "application",
  "availability",
  "baseMaterial",
  "category",
  "countryOfOrigin",
  "cityOfOrigin",
  "construction",
  "currency",
  "collectionName",
  "collectionTag",
  "design",
  "finish",
  "indoorOutdoor",
  // "priceLowerLimit",
  // "priceUpperLimit",
  "productSize",
  "quantity",
  "supplierName",
];
export const ProductDrawer = (props) => {
  const { Panel } = Collapse;

  const [allSpecs, setAllSpecs] = useState(null);
  const [dimensionSpecs, setDimensionSpecs] = useState(null);
  const [majorSpecs, setMajorSpecs] = useState(null);

  const [priceLowerLimit, setPriceLowerLimit] = useState(0);
  const [priceUpperLimit, setPriceUpperLimit] = useState(0);
  const setValues = () => {
    const properties = [];
    const variantIndex = 0;
    const dimenProperties = [];
    const majorProperties = [];
    if (variantIndex < props.product?.variants?.length) {
      // Reset the price range
      setPriceLowerLimit(null);
      setPriceUpperLimit(null);
      Object.keys(specsConstants).forEach((key) => {
        if (
          Array.isArray(props.product?.variants[variantIndex][key]) &&
          props.product?.variants[variantIndex][key]?.length > 0
        ) {
          var arrString = props.product?.variants[variantIndex][key].join(", ");
          if (dimensionConst.includes(key)) {
            if (key == "packingSize") {
              dimenProperties.push({
                name: specsConstants[key],
                value: arrString + " pcs",
              });
            } else if (
              key == "weightPerBoxLowerLimit" ||
              key == "weightPerBoxUpperLimit"
            ) {
              dimenProperties.push({
                name: specsConstants[key],
                value: arrString + " kgs",
              });
            } else {
              dimenProperties.push({
                name: specsConstants[key],
                value:
                  arrString +
                  (key.toLowerCase().includes("area") ? " sqft" : "mm"),
              });
            }
          } else if (majorConst.includes(key)) {
            majorProperties.push({
              name: specsConstants[key],
              value: arrString,
            });
          } else if (
            key === "priceLowerLimit" ||
            key === "priceUpperLimit" ||
            key === "currency"
          ) {
          } else {
            properties.push({ name: specsConstants[key], value: arrString });
          }
        } else if (
          typeof props.product?.variants[variantIndex][key] === "string" &&
          props.product?.variants[variantIndex][key] !== ""
        ) {
          if (dimensionConst.includes(key)) {
            if (key == "packingSize") {
              dimenProperties.push({
                name: specsConstants[key],
                value: props.product?.variants[variantIndex][key] + "pcs",
              });
            } else if (
              key == "weightPerBoxLowerLimit" ||
              key == "weightPerBoxUpperLimit"
            ) {
              dimenProperties.push({
                name: specsConstants[key],
                value: props.product?.variants[variantIndex][key] + " kgs",
              });
            } else {
              dimenProperties.push({
                name: specsConstants[key],
                value:
                  props.product?.variants[variantIndex][key] +
                  (key.toLowerCase().includes("area") ? " sqft" : "mm"),
              });
            }
          } else if (majorConst.includes(key)) {
            if (key == "currency") {
            } else {
              majorProperties.push({
                name: specsConstants[key],
                value: props.product?.variants[variantIndex][key],
              });
            }
            if (key === "priceLowerLimit") {
              setPriceLowerLimit(
                props.product?.variants[variantIndex][key] ?? null
              );
            } else if (key === "priceUpperLimit") {
              setPriceUpperLimit(
                props.product?.variants[variantIndex][key] ?? null
              );
            }
          } else if (key === "priceLowerLimit") {
            setPriceLowerLimit(
              props.product?.variants[variantIndex][key] ?? null
            );
          } else if (key === "priceUpperLimit") {
            setPriceUpperLimit(
              props.product?.variants[variantIndex][key] ?? null
            );
          } else {
            properties.push({
              name: specsConstants[key],
              value: props.product?.variants[variantIndex][key],
            });
          }
        }
      });
      setAllSpecs(properties);
      setDimensionSpecs(dimenProperties);
      setMajorSpecs(majorProperties);
    }
  };
  useEffect(() => {
    setValues();
  }, [props.product]);
  return (
    <Drawer
      title="Product Details"
      placement="right"
      onClose={() => props.setProduct(null)}
      visible={!!props.product}
    >
      <section className={styles.container}>
        <div
          className={styles.image}
          style={{
            backgroundImage: `url("${props.product?.images[0]?.imageUrl}")`,
          }}
        />
        <div className={styles.vendor}>{props.product?.vendorName}</div>
        <div className={styles.title}>{props.product?.title}</div>

        <Collapse defaultActiveKey={["1"]} ghost>
          <Panel header="Specification" key="1">
            {majorSpecs?.map((spec) => {
              return (
                <Row>
                  <Col sm={12} className={styles.bold}>
                    {spec?.name} :
                  </Col>
                  <Col sm={12}>{spec?.value}</Col>
                </Row>
              );
            })}
          </Panel>
          <Panel header="Weight & Dimensions" key="2">
            {dimensionSpecs?.map((spec) => {
              return (
                <Row>
                  <Col sm={12} className={styles.bold}>
                    {spec?.name} :
                  </Col>
                  <Col sm={12}>{spec?.value}</Col>
                </Row>
              );
            })}
          </Panel>
          <Panel header="Description" key="3">
            <p>{props.product?.variants[0]?.description}</p>
          </Panel>
        </Collapse>
      </section>
    </Drawer>
  );
};
